import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles/index';
import classNames from 'classnames';
import GoogleMap from 'google-map-react';
import ReactTable from "react-table";
import {Select, Button, Card, Tooltip, Divider, FormControl, Icon, MenuItem, Typography} from 'material-ui';

const styles = theme => ({
    root: {}
});

function Marker({ text }) {

    return (
        <Tooltip title={text} placement="top">
            <Icon className="text-red">place</Icon>
        </Tooltip>
    );
}

class Widget13 extends Component {

    state = {
        dataset: 'Next 10 Days'
    };

    setDataSet = (ev) => {
        this.setState({dataset: ev.target.value});
    };

    render() {
        const { data, classes } = this.props;
        const {dataset} = this.state;

        return (
            <Card className={classNames(classes.root, "w-full h-512")}>

                <div className="p-16">
                    <Typography className="h1 font-300">Re Calibration Reminders</Typography>
                </div>

                <div className="p-16 flex flex-row items-center justify-between ">
                    <div>
                        <FormControl className="">
                            <Select value={dataset} onChange={this.setDataSet}>
                                {Object.keys(data.datasets).map(key => (
                                    <MenuItem key={key} value={key}>{key}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    {/* <Button size="small">OVERVIEW</Button> */}
                </div>

                <ReactTable className="w-full"
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: (e, handleOriginal) => {

                            }
                        }
                    }}
                    // data={this.state.data}
                    columns={[

                        {
                            Header: "Job id",
                            accessor: "id",
                            show: false
                        },

                        {
                            Header: "Job No",
                            accessor: "jobNo",
                            // show: false,
                            filterable: true
                        },
                        {
                            Header: "Customer Name",
                            accessor: "customerName",
                            filterable: true

                        },
                        {
                            Header: "Re-cal Date",
                            accessor: "date",
                            filterable: true

                        },

                        {
                            Header: "",
                            // accessor: "su",
                            width: 128,
                            Cell: row => (
                                <div className="flex items-center w-8 h-8">


                                </div>
                            )
                        }

                    ]}
                    defaultPageSize={10}
                    className="-striped -highlight"
                />

            </Card>
        );
    }
}

export default withStyles(styles, { withTheme: true })(Widget13);



// WEBPACK FOOTER //
// ./src/main/content/apps/dashboards/widgets/Widget13.js